import { UserClient } from './UserClient';
import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';

export class UserService {

    private readonly userClient: UserClient;

    public constructor(private readonly authService: IAuthServiceV2) {
        this.userClient = new UserClient(this.authService);
    }

    public async getCurrentUserEmail(): Promise<string> {
        const userData = await this.userClient.getCurrentUser();
        return userData.email ? userData.email : '';
    }

    public async getCurrentUserId(): Promise<string> {
        const userData = await this.userClient.getCurrentUser();
        return userData.sub ? userData.sub : '';
    }

}
